import request from "@/CommonDP/utils/request";

export default {
  startApply(json) {
    return request.post(`/flow/leave/start`, json);
  },

  restartApply(json) {
    return request.post(`/flow/leave/restart`, json);
  },

  queryDetail(flowInstanceId) {
    return request.get(`/flow/leave/detail?flowInstanceId=${flowInstanceId || ""}`);
  },

  queryDraft(leaveId) {
    return request.post(`/flow/leaveWithDraft/query?id`, leaveId);
  },
  leaveWtihDraftSaveDraft(json) {
    return request.post(`/flow/leaveWithDraft/save`, json);
  },
  leaveWtihDraftStart(json) {
    return request.post(`/flow/leaveWithDraft/start`, json);
  },

  leaveWtihDraftRestart(json) {
    return request.post(`/flow/leaveWithDraft/restart`, json);
  },

  leaveWtihDraftDetail(flowInstanceId) {
    return request.get(`/flow/leaveWithDraft/detail?flowInstanceId=${flowInstanceId || ""}`);
  }
};
